import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Controller, useWatch, useFormContext} from 'react-hook-form';
import {
  Divider,
  RadioGroup,
  FormControlLabel,
  Radio,
  Collapse,
} from '@material-ui/core';

import {useShippingMethodConfig} from '../../utils';
import PickupMethod from './PickupMethod';
import ShippingMethod from './ShippingMethod';
import {colors} from '../../../../assets/styles/colors';
import {DELIVERY_FORM_FIELDS} from './constant';
import type {ShippingAddress} from '../../../../entities';
import type {
  DeliveryMethodType,
  ShippingMethodType,
} from '../../../../entities/logistic/delivery-method';

const useStyles = makeStyles(theme => ({
  divider: {
    background: colors.grey200,
    width: '100%',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: '1rem',
  },
  errorMessage: {
    color: colors.danger,
    fontSize: '0.75rem',
  },
}));

type Props = {
  defaultDeliveryAddress?: ShippingAddress,
  defaultDeliveryMethod?: DeliveryMethodType,
  defaultCreationType?: ShippingMethodType,
  isEditing?: boolean,
};

export default function DeliveryForm(props: Props) {
  const {
    defaultDeliveryAddress,
    defaultDeliveryMethod,
    defaultCreationType,
    isEditing,
  } = props;
  const classes = useStyles();
  const {errors} = useFormContext();

  const deliveryMethodSelected = useWatch({
    name: DELIVERY_FORM_FIELDS.DELIVERY_METHOD,
  });

  const {shippingMethod, pickupMethod} = useShippingMethodConfig();

  const enabledPickUpMethod = pickupMethod && pickupMethod.enabled;
  const enabledShippingMethod = shippingMethod && shippingMethod.enabled;

  return (
    <div>
      <Controller
        name={DELIVERY_FORM_FIELDS.DELIVERY_METHOD}
        rules={{required: 'Seleccione un método de entrega'}}
        render={({onChange, onBlur, value, name, ref}) => {
          return (
            <div className={classes.radioGroup}>
              <RadioGroup
                onChange={e => onChange(e.target.value)}
                value={value ?? ''}
              >
                {enabledPickUpMethod && (
                  <FormControlLabel
                    value="PICK_UP"
                    control={<Radio color="primary" />}
                    label="Recoger en tienda"
                  />
                )}
                {enabledPickUpMethod && enabledShippingMethod && (
                  <Divider
                    className={classes.divider}
                    style={{margin: '8px 0px'}}
                  />
                )}
                {enabledShippingMethod && (
                  <FormControlLabel
                    value="SHIPPING"
                    control={<Radio color="primary" />}
                    label="Delivery"
                  />
                )}
                {deliveryMethodSelected && (
                  <Divider
                    className={classes.divider}
                    style={{margin: '8px 0px'}}
                  />
                )}
              </RadioGroup>
              {errors[DELIVERY_FORM_FIELDS.DELIVERY_METHOD] && (
                <span className={classes.errorMessage}>
                  {errors[DELIVERY_FORM_FIELDS.DELIVERY_METHOD].message}
                </span>
              )}
            </div>
          );
        }}
      />

      <Collapse in={deliveryMethodSelected === 'SHIPPING'}>
        {deliveryMethodSelected === 'SHIPPING' && (
          <ShippingMethod
            isEditing={isEditing}
            defaultDeliveryAddress={
              defaultDeliveryMethod === 'SHIPPING'
                ? defaultDeliveryAddress
                : undefined
            }
            defaultCreationType={defaultCreationType}
          />
        )}
      </Collapse>

      <Collapse in={deliveryMethodSelected === 'PICK_UP'}>
        {deliveryMethodSelected === 'PICK_UP' && (
          <PickupMethod isEditing={!!defaultDeliveryMethod} />
        )}
      </Collapse>
    </div>
  );
}
